import { render, staticRenderFns } from "./DarkModeToggler.vue?vue&type=template&id=9a889c98"
import script from "./DarkModeToggler.vue?vue&type=script&lang=js"
export * from "./DarkModeToggler.vue?vue&type=script&lang=js"
import style0 from "./DarkModeToggler.vue?vue&type=style&index=0&id=9a889c98&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports